<template>

	<div>
		<app-boards board-key="company_anonymous"></app-boards>
	</div>

</template>

<script>
import AppBoards from "@/components/boards/appBoards";
export default {
	name: "secret",
	components: {AppBoards}
}
</script>

<style scoped>

</style>